<form class="flex align-items-center w-full"
      [formGroup]="selectForm" [ngClass]="{'custom-select-min-h-1': isAutoOpen}">
    <mat-form-field class="w-full"
                    [ngClass]="{'without-margin' : showPlaceholder}">
        <mat-label [ngClass]="{'d-none' : showPlaceholder}">{{label}}</mat-label>
        <mat-select [multiple]="multi" #matSelectMulti
                    [disabled]="selectForm.get(formField).disabled"
                    [required]="required"
                    [placeholder]="placeholder"
                    [formControlName]="formField"
                    (openedChange)="opened($event)"
                    (selectionChange)="checkedData($event.value)">
            <ng-container *ngIf="showSearchField">
                <input placeholder="Search" class="select-search" type="text"
                       (mousedown)="selectForm.get(formField).disable()"
                       [formControl]="search">
            </ng-container>
            <mat-checkbox value="0" (click)="toggleAllSelection()"
                          *ngIf="multi && showToggleAllButton && selectedItems && selectedItems.length && !arrayItemsEmpty">
                Select all
            </mat-checkbox>
            <ng-container *ngIf="isGroup; else defaultOption">

                <!--                                <ng-container *ngIf="showAddCategory">-->
                <!--                                    <ng-container-->
                <!--                                            *ngIf="!isShowCategoryForm && selectedItems && selectedItems.length && !arrayItemsEmpty;">-->
                <!--                                        <mat-option class="hide-checkbox pl-8" (click)="showCategoryForm(null)">-->
                <!--                                            <span class="lick">Add new category</span>-->
                <!--                                        </mat-option>-->
                <!--                                    </ng-container>-->
                <!--                                    <ng-container-->
                <!--                                            *ngIf="isShowCategoryForm && selectedItems && selectedItems.length && !arrayItemsEmpty;">-->
                <!--                                        <ng-container [ngTemplateOutlet]="categoryForm"-->
                <!--                                                      [ngTemplateOutletContext]="{ id: null }"></ng-container>-->
                <!--                                    </ng-container>-->
                <!--                                </ng-container>-->
                <ng-container *ngFor="let group of selectedItems">
                    <ng-container *ngIf="group">
                        <mat-optgroup [label]="group.name"
                                      [disabled]="!group[groupField] || !group[groupField].length">
                            <mat-option *ngFor="let _item of group[groupField]" [value]="getValue(_item)"
                                        class="pl-8">
                                {{ _item.name ? _item.name
                                : _item.label ? _item.label
                                    : _item.title ? _item.title
                                        : _item }}
                            </mat-option>
                            <!--                                            <ng-container *ngIf="showAddCategory">-->
                            <!--                                                <ng-container-->
                            <!--                                                        *ngIf="!selectedGroupId || selectedGroupId !== group.id; else subCategoryBlock">-->
                            <!--                                                    <mat-option class="hide-checkbox pl-8" (click)="showCategoryForm(group.id)">-->
                            <!--                                                        <span class="lick">Add new subcategory</span>-->
                            <!--                                                    </mat-option>-->
                            <!--                                                </ng-container>-->
                            <!--                                                <ng-template #subCategoryBlock>-->
                            <!--                                                    <ng-container *ngIf="selectedGroupId === group.id"-->
                            <!--                                                                  [ngTemplateOutlet]="categoryForm"-->
                            <!--                                                                  [ngTemplateOutletContext]="{ id: group.id }"></ng-container>-->
                            <!--                                                </ng-template>-->
                            <!--                                            </ng-container>-->
                        </mat-optgroup>
                    </ng-container>
                    <mat-option class="text-center hide-checkbox" *ngIf="!group" disabled>
                        No records found!
                    </mat-option>
                </ng-container>
            </ng-container>
            <ng-template #defaultOption>
                <ng-container *ngIf="selectedItems && selectedItems.length">
                    <ng-container *ngFor="let _item of selectedItems;">
                        <ng-container *ngIf="_item && ((currentId && currentId !== getValue(_item)) || !currentId)">
                            <mat-option [value]="getValue(_item)">
                                {{ _item.name ? _item.name
                                : _item.label ? _item.label
                                    : _item.title ? _item.title
                                        : _item.email ? _item.email
                                            : _item.subject ? _item.subject
                                                : _item }}
                                <!--                                <span *ngIf="showUsersCount(_item)">-->
                                <!--                                    (A: {{_item.active_users_count}}, T: {{_item.users_count}})-->
                                <!--                                </span>-->
                                <span *ngIf="showChannelsInName">
                                <ng-container *ngFor="let channel of _item.channels; let last = last">
                                    <span>{{channel}}<span *ngIf="!last">,</span></span>
                                </ng-container>
                            </span>
                            </mat-option>
                        </ng-container>
                        <mat-option class="text-center hide-checkbox" *ngIf="!showAutoLoading && !_item" disabled>
                            No records found!
                        </mat-option>
                    </ng-container>
                </ng-container>
            </ng-template>
            <p class="h-10 text-center leading-10" *ngIf="!selectedItems || !selectedItems.length">No records found!</p>

            <div class="h-10 flex justify-content-center" *ngIf="showAutoLoading">
                <mat-progress-spinner
                        *ngIf="showAutoLoading"
                        [diameter]="24"
                        [mode]="'indeterminate'"></mat-progress-spinner>
            </div>
        </mat-select>
        <mat-error *ngIf="selectForm.get(formField).invalid && selectForm.get(formField).touched">
            {{_formUtilsService.getErrorMessage(selectForm, formField)}}
        </mat-error>
    </mat-form-field>
    <ng-container *ngIf="showClearIcon && (selectForm.get(formField).value || selectForm.get(formField).value === 0)">
        <button class="previous-button mt-2 ml-1"
                mat-icon-button
                (click)="clearField(selectForm.get(formField))">
            <mat-icon svgIcon="mat_outline:close"></mat-icon>
        </button>
    </ng-container>
</form>

<!--<ng-container *ngIf="currentId && currentId !== getValue(_item); else defaultOptionGroup">-->
<!--    <mat-option [value]="getValue(_item)"-->
<!--                class="pl-8">-->
<!--        {{currentId}}-->
<!--        {{_item.id}}-->
<!--        {{ _item.name ? _item.name : _item.label ? _item.label : _item }}-->
<!--    </mat-option>-->
<!--</ng-container>-->
<!--<ng-template #defaultOptionGroup>-->
<!--    <mat-option [value]="getValue(_item)"-->
<!--                class="pl-8">-->
<!--        {{ _item.name ? _item.name : _item.label ? _item.label : _item }}-->
<!--    </mat-option>-->
<!--</ng-template>-->

<!--<ng-template let-id="id" #categoryForm>-->
<!--    <form class="flex items-center px-4" [ngClass]="{'px-8': id}" (submit)="addCategory(id)">-->
<!--        <mat-form-field class="w-2/3">-->
<!--            &lt;!&ndash;            <mat-label>Add categories</mat-label>&ndash;&gt;-->
<!--            <input matInput placeholder="Name" type="text"-->
<!--                   autocomplete="off"-->
<!--                   [formControl]="name">-->
<!--            <mat-error>-->
<!--                Name is required-->
<!--            </mat-error>-->
<!--        </mat-form-field>-->
<!--        <div class="flex w-1/3 mb-4 items-center" [ngClass]="{'mb-8': name.invalid && name.touched}">-->
<!--            <button class="min-w-10 ml-2 w-10"-->
<!--                    mat-stroked-button-->
<!--                    [color]="'accent'"-->
<!--                    type="submit">-->
<!--                <mat-icon [svgIcon]="'add'"></mat-icon>-->
<!--            </button>-->
<!--            <button mat-stroked-button-->
<!--                    type="button"-->
<!--                    class="min-w-10 ml-2 w-10"-->
<!--                    [color]="'warn'"-->
<!--                    (click)="hideCategoryForm()">-->
<!--                <mat-icon svgIcon="mat_outline:close"></mat-icon>-->
<!--            </button>-->
<!--        </div>-->
<!--    </form>-->
<!--</ng-template>-->
